<template>
  <div class="page-content movie">
    <h1 class="page-title">{{ $locale("sideMenu.film.library") }}</h1>

    <!-- Search Area -->
    <el-row class="search-area">
        <el-col :span="16">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-input :placeholder="$locale('movie.searchName')" v-model="onSearch.name">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-col>
            <el-col :span="6">
              <el-select v-model="onSearch.sort" clearable>
                <el-option
                  v-for="item in sortOptions"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-select v-model="viewType">
                <el-option :label="$locale('movie.display.picture')" value="picture"></el-option>
                <el-option :label="$locale('movie.display.list')" value="list"></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-select v-model="onSearch.sortType">
                <el-option
                  v-for="item in sortTypeOptions"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-select v-model="onSearch.approve" clearable>
                <el-option :label="$locale('movie.approveTrue')" :value="true"></el-option>
                <el-option :label="$locale('movie.approveFalse')" :value="false"></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-button class="egl-btn-yellow" @click="search_fn">{{ $locale("global.search") }}</el-button>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8" class="ta-r">
            <el-button class="egl-btn-gray" v-if="getApproveItem().length === 0 && adminType !== 'superAdmin'" disabled>{{ $locale("global.approve") }}</el-button>
            <el-button class="egl-btn-yellow" v-else-if="adminType !== 'superAdmin' && getApproveItem().length > 0" @click="approve_fn">{{ $locale("global.approve") }}</el-button>
            <el-button class="egl-btn-yellow" @click="toDetail()">{{ $locale("movie.createMovie") }}</el-button>
        </el-col>
    </el-row>
    <div v-if="viewType === 'picture'">
      <el-row :gutter="20" class="movie-list" scroll-container ref="movieListContainer" v-if="movieList.length > 0">
      <el-col :span="4" v-for="movie in movieList" :key="movie.id" class="item-with-del-btn" :title="movie.name">
        <div class="item-container" @click="toDetail(movie.id)">
          <a class="btn-del-item" @click.stop="delete_fn(movie.id, movie.name)">
            <i class="el-icon-delete">&nbsp;</i>
          </a>
          <el-image :src="convertImageUrl(movie.img)" :alt="movie.name" class="item-thumbnail" :lazy="true">
            <div slot="error" class="image-error-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
            <div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i>
            </div>
          </el-image>
        </div>
        <p :title="movie.name" @click="toDetail(movie.id)" class="item-name list-table">
          <i class="el-icon-circle-check change" v-if="!movie.approve && !movie.reflect && adminType !== 'superAdmin'"></i>
          {{ movie.name }}
        </p >
      </el-col>
      </el-row>
      <div v-else class="movie-list-empty">
        <p>{{ $locale("global.noData") }}</p>
      </div>
    </div>
    <el-table
      v-else
      :data="movieListForTable"
      class="egl-table list-table"
      stripe
    >
      <el-table-column :label="$locale('global.change')" width="50" align="center">
        <template slot-scope="scope">
          <i class="el-icon-circle-check change" v-show="!scope.row.approve && !scope.row.reflect && adminType !== 'superAdmin'"></i>
        </template>
      </el-table-column>
      <el-table-column
        :label="$locale('global.titleOfWork')"
        prop="name"
      ></el-table-column>
      <el-table-column :label="$locale('global.control')" align="center" width="160">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="toDetail(scope.row.id)">{{ $locale("global.edit") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="delete_fn(scope.row.id, scope.row.name)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <CommPagination
      :total="pageCount"
      :curPage="onSearch.page"
      :pageSize="onSearch.pageSize"
      @current-change="choosePage"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getMovieList } from "@/helpers/service/api/common.js";
import { deleteMovie, approveMovieService } from "@/helpers/service/api/movie.js";
import countDownAlert from "@/utils/countDownAlert";
import { sortTypeOptions } from "@/assets/js/movieStatic";
import CommPagination from "@/components/common/CommPagination";
import "@/assets/style/movie.less";
import { localStorage } from "@/utils/localStorage";

import filterOptions from '@/mixins/filterOptions';
import { saveFilterOptions } from "@/utils/filterOptions";
import { convertImageUrl } from "@/utils/common";

export default {
  name: "movie-list",
  mixins: [ filterOptions ],
  data() {
    return {
      viewType: "picture",
      onSearch: {
        name: "",
        sort: "sort",
        page: 0,
        pageSize: 24,
        sortType: "ASC",
        approve: null,
      },
      pageCount: 0,
      movieListForTable: [],
      movieList: [],
      sortOptions: [
        {
          label: this.$locale("global.name"),
          value: "name",
        },
        {
          label: this.$locale("movie.openStr"),
          value: "releaseTime",
        },
        {
          label: this.$locale("movie.sortByTime"),
          value: "createTime",
        },
        {
          label: this.$locale("movie.sortOf"),
          value: "sort",
        },
        {
          label: this.$locale("movie.sortById"),
          value: "filmSearchId",
        }
      ],
      approveShow: false,
      sortTypeOptions,
      convertImageUrl,
    };
  },
  computed: {
    ...mapState("app", {
      cinemaId: state => state.cinemaId,
      brandId: state => state.brandId,
      adminType: state => state.adminType,
    }),
  },
  methods: {
    toggleApprove() {
      this.$refs.approve.toggleApprove();
    },
    choosePage(page) {
      this.onSearch = {
        ...this.onSearch,
        page: page - 1,
      };
      this.getList();
    },
    toDetail(id = "") {
      if (id == "") {
        this.$router.push({ path: "/movie/create" });
      } else {
        this.$router.push({ path: `/movie/update/${id}` });
      }
    },
    getList() {
      const requestParam = {
        ...this.onSearch,
        status: "active",
        cinemaId: this.cinemaId
      };

      getMovieList(requestParam)
        .then(res => {
          if (res.success) {
            this.$nextTick(() => {
              if (this.$refs.movieListContainer) {
                this.$refs.movieListContainer.$el.scrollTo(0, 0);
              }
            });

            let movieArr = [];
            let movieArrForTable = [];

            res.data.data.map(movie => {
              movieArr.push({
                id: movie.id,
                name: movie.name,
                img: movie.posters,
                approve: movie.approve,
                reflect: movie.reflect,
              });
              movieArrForTable.push({
                id: movie.id,
                name: movie.name,
                approve: movie.approve,
                reflect: movie.reflect,
              })
            });

            this.movieList = movieArr;
            this.movieListForTable = movieArrForTable;
            // this.pageCount = Math.ceil(res.data.count / 24);
            this.pageCount = res.data.count || 0;
          }
        })
        .catch(() => {});
    },
    search_fn() {
      // search之前 保存用户的filterOptions
      const obj = {
        id: localStorage.get('loginAsAccountId') || localStorage.get('accountId'),
        options: {
          onSearch: this.onSearch,
          viewType: this.viewType,
        }
      }
      saveFilterOptions(obj, 'movie_filterOptions')
      // 获取movieList
      this.getList();
    },
    delete_fn(id, name) {
      const that = this;
      const movieName = name;
      const movieId = id;
      const confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${movieName}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false,
      }).then(() => {
        // confirm
        deleteMovie({ id: movieId }).then(res => {
          if (res.success) {
            countDownAlert({
              content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                that.getList();
              }
            });
          }
        });
      });
    },
    approve_fn() {
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.approveAll")}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.approve"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          approveMovieService({
            ...this.adminType === "brand" ? { brandId: this.brandId } : { cinemaId: this.cinemaId },
            accountType: this.adminType,
          }).then(() => {
            this.getList();
          });
        });
    },
    getApproveItem() {
      let approveArr = [];
      let { movieList } = this;
      for (let i = 0; i < movieList.length; i++) {
        if (!movieList[i].approve && !movieList[i].reflect) {
          approveArr.push(movieList[i].id);
        }
      }
      return approveArr;
    },
  },
  mounted() {
    this.loadOptions('movie_filterOptions', (val) => {
      const { options } = val
      this.onSearch = options.onSearch;
      this.viewType = options.viewType;
    })
    this.getList();
  },
  components: {
    CommPagination,
  },
};
</script>

<style scoped lang="less">
.movie {
  padding-bottom: 0;

  .movie-list, 
  .movie-list-empty {
    height: calc(100vh - 320px);
  }

  .movie-list {
    overflow: auto;
  }

  .movie-list-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
  }
}
</style>
